import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';
import { RoomSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/room-single-select/room-single-select.component';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'crm-pass-car-modal',
  standalone: true,
  imports: [CommonModule, RoomSingleSelectComponent, ButtonModule],
  templateUrl: './pass-car-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PassCarModalComponent {
  public rooms: RoomFindInterface[] = [];
  public selectedRoom: RoomFindInterface;

  public constructor(private readonly ref: DynamicDialogRef, private readonly config: DynamicDialogConfig) {
    this.rooms = config.data.rooms;
  }

  public approve() {
    this.ref.close(this.selectedRoom);
  }
}
